module.exports = {
      id: "myvikatanbadge-usage",
      viewBox: "0 0 499.854 524.656",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#myvikatanbadge",
      toString: function () {
        return this.url;
      }
    }